module.exports = __webpack_public_path__ + "img/f4f0cd9.webp";